import React, { Component } from 'react'

export default class FifthDiv extends Component {
  render() {
    return (
      <div className='fifth-div'>
        <h3>Distributors</h3>
        <a href='#'>Find Distributors<i class='bx bx-chevron-right'></i></a>
        <a href='#'>Try Push in-store<i class='bx bx-chevron-right'></i></a>
      </div>
    )
  }
}
